import { useTheme } from '@/components/ThemeProvider';
import { cn } from '@/lib/utils';
import { ComponentPropsWithRef } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps extends ComponentPropsWithRef<'div'> {}

export default (props: IProps) => {
  const { ...attr } = props;
  const { theme } = useTheme();
  const { t } = useTranslation();
  const imgSrc = theme == 'dark' ? '/icon/docs.svg' : '/icon/docs_black.svg';
  return (
    <div
      className={cn('px-[8px] h-[32px] rounded-[8px] flex border-borderColor border-[1px] items-center gap-x-[4px] text-[12px]', attr.className)}
      onClick={() => window.open('https://docs.boom.meme/basic/signal', '_blank')}
    >
      <img src={imgSrc} className="size-[18px]" />
      {t('Signal.howItWorks')}
    </div>
  );
};
